module.exports = __webpack_public_path__ + "static/media/logo.c9b9787f.png";